var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M16.75 2a.75.75 0 0 0-1.5 0v1.25h-6.5V2a.75.75 0 0 0-1.5 0v1.25H5A2.75 2.75 0 0 0 2.25 6v14A2.75 2.75 0 0 0 5 22.75h14A2.75 2.75 0 0 0 21.75 20V6A2.75 2.75 0 0 0 19 3.25h-2.25V2Zm3.5 7.25V6c0-.69-.56-1.25-1.25-1.25h-2.25V6a.75.75 0 0 1-1.5 0V4.75h-6.5V6a.75.75 0 0 1-1.5 0V4.75H5c-.69 0-1.25.56-1.25 1.25v3.25h16.5Zm-16.5 1.5h16.5V20c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-9.25Z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendar;